import { Shield, LogIn } from 'lucide-react';

interface LoginPageProps {
  onLogin: () => void;
}

export function LoginPage({ onLogin }: LoginPageProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-950 via-purple-950/40 to-indigo-950/50 px-4">
      {/* Decorative background elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-purple-500/10 rounded-full blur-3xl" />
        <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-indigo-500/10 rounded-full blur-3xl" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-purple-600/5 rounded-full blur-3xl" />
      </div>

      <div className="relative w-full max-w-md">
        {/* Glass-morphism card */}
        <div className="backdrop-blur-xl bg-white/[0.05] border border-white/[0.08] rounded-2xl shadow-2xl shadow-purple-500/5 p-8 sm:p-10">
          {/* Shield icon */}
          <div className="flex justify-center mb-6">
            <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-purple-500/20 to-indigo-500/20 border border-purple-500/20 flex items-center justify-center">
              <Shield className="w-8 h-8 text-purple-400" />
            </div>
          </div>

          {/* Title */}
          <h1 className="text-3xl font-bold text-gray-100 text-center tracking-tight">
            Fabric Monitor
          </h1>

          {/* Subtitle */}
          <p className="mt-2 text-sm font-medium text-purple-300/80 text-center">
            Linc Microsoft Fabric Monitoring Dashboard
          </p>

          {/* Divider */}
          <div className="my-6 border-t border-white/[0.06]" />

          {/* Description */}
          <p className="text-sm text-gray-400 text-center leading-relaxed">
            Monitor your mirrored databases, track replication status, and
            identify issues in real-time.
          </p>

          {/* Sign in button */}
          <button
            onClick={onLogin}
            className="mt-8 w-full flex items-center justify-center gap-3 px-6 py-3 bg-blue-600 hover:bg-blue-500 active:bg-blue-700 text-white font-medium rounded-xl transition-all duration-200 shadow-lg shadow-blue-600/20 hover:shadow-blue-500/30 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-gray-950"
          >
            <LogIn className="w-5 h-5" />
            Sign in with Microsoft
          </button>

          {/* Footer */}
          <p className="mt-6 text-xs text-gray-500 text-center">
            Access restricted to Linc organization members
          </p>
        </div>
      </div>
    </div>
  );
}
